import { Paths } from "@stage/path";
export function useShape(target, options) {
  var viewBox = options.viewBox,
    grid = options.grid,
    _options$zoom = options.zoom,
    zoom = _options$zoom === void 0 ? 1 : _options$zoom,
    paths = options.paths;
  var dWidth = target.width / zoom;
  var dHeight = target.height / zoom;
  return {
    paths: paths.map(function (shapePath) {
      var _shapePath$round = shapePath.round,
        round = _shapePath$round === void 0 ? 0 : _shapePath$round,
        define = shapePath.define,
        fill = shapePath.fill,
        stroke = shapePath.stroke,
        strokeWidth = shapePath.strokeWidth,
        strokeDasharray = shapePath.strokeDasharray;
      var scaleX = 1;
      var scaleY = 1;
      var width = dWidth;
      var height = dHeight;
      var path = Paths.parse(define);
      if (grid) {
        path = Paths.expandGrid(path, grid, {
          x: dWidth - viewBox.width,
          y: dHeight - viewBox.height
        });
      } else {
        scaleX = dWidth / viewBox.width;
        scaleY = dHeight / viewBox.height;
        width = viewBox.width;
        height = viewBox.height;
      }
      if (round) {
        path = Paths.rounding(path, round);
      }
      return {
        fill: fill,
        stroke: stroke,
        strokeDasharray: strokeDasharray,
        strokeWidth: strokeWidth,
        path: path,
        width: width,
        height: height,
        transform: {
          originX: 0,
          originY: 0,
          scaleX: scaleX,
          scaleY: scaleY
        }
      };
    })
  };
}